import { render, staticRenderFns } from "./Block6.vue?vue&type=template&id=01aa343d&scoped=true"
import script from "./Block6.vue?vue&type=script&lang=js"
export * from "./Block6.vue?vue&type=script&lang=js"
import style0 from "./Block6.vue?vue&type=style&index=0&id=01aa343d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa343d",
  null
  
)

export default component.exports